import OTP_SETUP from'@graphql/mutations/OtpSetup.graphql';import{useMutationWithValidationErrors}from'./useMutationWithValidationErrors';const useOtpSetup=()=>useMutationWithValidationErrors(OTP_SETUP,data=>undefined,(cache,response)=>{// const playlist = response.data?.OtpSetup?.playlist;
// if (!playlist) return;
// const data = cache.readQuery<GetPlaylists>({
//   query: GET_PLAYLISTS
// });
// if (!data) return;
// const newData: GetPlaylists = {
//   playlists: [...data.playlists, playlist]
// };
// cache.writeQuery({
//   query: GET_PLAYLISTS,
//   data: newData
// });
});export default useOtpSetup;